import { CITY } from '@lts-web/types/LocationTypes';

export default ({
    systemTypes = [],
    locationType = CITY,
    cityCode = '',
    cityName = '',
    countryCode = '',
    countryName = '',
    airportCode = '',
    airportName = '',
    hotelCode = '',
    hotelName = '',
    imageSrc = ''
}) => ({
    systemTypes,
    locationType,
    cityCode,
    cityName,
    countryCode,
    countryName,
    airportCode,
    airportName,
    hotelCode,
    hotelName,
    imageSrc
});